/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Pagination from "../../Helpers/Pagination";
import { Modal, ModalBody, Row, Col, Badge, Input, Button, Card, CardBody } from "reactstrap";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { toast } from "react-toastify";
import DeleteModal from "../Common/DeleteModal";

const VehicleList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [viewItem, setViewItem] = useState(null);
    const [deleteTarget, setDeleteTarget] = useState(null);
    const [deleting, setDeleting] = useState(false);

    // Expense History States
    const [expenseModal, setExpenseModal] = useState(false);
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [expenseList, setExpenseList] = useState([]);
    const [expensePage, setExpensePage] = useState(1);
    const [expenseTotal, setExpenseTotal] = useState(0);
    const [summary, setSummary] = useState({ total_records: 0, overall_total_amount: 0 });
    
    // Expense Filter States
    const [expFilters, setExpFilters] = useState({
        type: "",
        from: null,
        to: null
    });

    const limit = 20;

    const loadVehicles = async () => {
        dispatch(loadingTrue());
        const offset = (page - 1) * limit;
        const res = await Handler({
            method: "get",
            url: `/vehicle/list.php?limit=${limit}&offset=${offset}&search=${search}`
        });
        if (res?.success) {
            setData((res?.data || []).filter(v => v.status !== 'maintenance'));
            setTotal(res.total_count || res?.total || res?.pagination?.total_rows || 0);
        }
        dispatch(loadingFalse());
    };

    const loadExpenseHistory = useCallback(async (v_id, p = 1) => {
        dispatch(loadingTrue());
        try {
            let url = `/expenses/by_list.php?vehicle_id=${v_id}&page=${p}&limit=5`;
            if (expFilters.type) url += `&expense_type=${expFilters.type}`;
            if (expFilters.from) url += `&from_date=${expFilters.from.format("YYYY-MM-DD")}`;
            if (expFilters.to) url += `&to_date=${expFilters.to.format("YYYY-MM-DD")}`;

            const res = await Handler({ method: "get", url });
            if (res?.success) {
                setExpenseList(res.data);
                setExpenseTotal(res.summary?.total_records || 0);
                setSummary({
                    total_records: res.summary?.total_records || 0,
                    overall_total_amount: res.summary?.overall_total_amount || 0
                });
                setExpensePage(res.pagination?.current_page || 1);
            }
        } catch (err) { console.error(err); }
        dispatch(loadingFalse());
    }, [dispatch, expFilters]);

    useEffect(() => { loadVehicles(); }, [page, search]);

    useEffect(() => {
        if (expenseModal && selectedVehicle) {
            loadExpenseHistory(selectedVehicle.id, expensePage);
        }
    }, [expensePage, expenseModal, selectedVehicle, loadExpenseHistory]);

    const openExpenseModal = (vehicle) => {
        setSelectedVehicle(vehicle);
        setExpensePage(1);
        setExpenseModal(true);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className="page-card">
                <div className="page-header">
                    <h4>Vehicles</h4>
                    <div className="search-box">
                        <i className='bx bx-search'></i>
                        <input
                            placeholder="Search vehicles..."
                            value={search}
                            onChange={e => { setPage(1); setSearch(e.target.value) }}
                        />
                    </div>
                </div>

                <div className="table-wrap">
                    <table className="table modern-table">
                        <thead>
                            <tr>
                                <th>Vehicle No</th>
                                <th>Lorry Type</th>
                                <th>Capacity</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th className="text-center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.length === 0 ? (
                                <tr><td colSpan="6" className="text-center">No vehicles found</td></tr>
                            ) : data?.map(v => (
                                <tr key={v.id}>
                                    <td className="fw-semibold text-uppercase">{v.vehicle_number}</td>
                                    <td>{v.lorry_type}</td>
                                    <td>{v.capacity}</td>
                                    <td>
                                        <span className={`status-badge vehicle-status ${v.status}`}>
                                            {v.status.replace("_", " ")}
                                        </span>
                                    </td>
                                    <td>{new Date(v.created_at).toLocaleDateString()}</td>
                                    <td className="text-center">
                                        <button
                                            className="icon-btn expense"
                                            title="View Expense History"
                                            onClick={() => openExpenseModal(v)}
                                            style={{ backgroundColor: '#ffc107', color: '#000', marginLeft: '5px', alignItems: 'center', display: 'inline-flex', gap: '4px', border: 'none', padding: '5px 10px', borderRadius: '4px' }}
                                        >
                                            Exp <i className='bx bx-money-withdraw'></i>
                                        </button>
                                        <button className="icon-btn view" onClick={() => setViewItem(v)}>
                                            <i className='bx bx-show'></i>
                                        </button>
                                        <button className="icon-btn edit" onClick={() => navigate(`/vehicle/edit/${v.id}`)}>
                                            <i className='bx bx-edit'></i>
                                        </button>
                                        <button className="icon-btn text-danger ms-1" title="Delete Vehicle"
                                             onClick={() => setDeleteTarget(v)}>
                                             <i className='bx bx-trash'></i>
                                         </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <Pagination
                    page={page}
                    total={total}
                    limit={limit}
                    onPrev={() => setPage(p => Math.max(1, p - 1))}
                    onNext={() => setPage(p => p + 1)}
                />

                {/* ✅ MACHAN: EXPENSE HISTORY MODAL WITH TOP SUMMARY CARD */}
                <Modal isOpen={expenseModal} toggle={() => setExpenseModal(false)} centered size="lg" className="extraordinary-modal">
                    <ModalBody className="p-0 overflow-hidden">
                        <div className="modal-banner" style={{ background: 'linear-gradient(45deg, #ffc107, #ff9800)' }}>
                            <div className="banner-content">
                                <div className="customer-icon" style={{ background: '#fff', color: '#ff9800' }}>
                                    <i className='bx bx-history'></i>
                                </div>
                                <div className="header-text">
                                    <h5 className="text-uppercase text-dark">{selectedVehicle?.vehicle_number} - EXPENSES</h5>
                                    <p className="text-dark">Overview of all operational costs</p>
                                </div>
                            </div>
                            <button className="glass-close" onClick={() => setExpenseModal(false)}><i className='bx bx-x'></i></button>
                        </div>

                        {/* ✅ MACHAN: TOP TOTAL SUMMARY CARD */}
                        <div className="px-3 pt-3">
                            <Card className="border-0 shadow-sm" style={{ background: '#fff9e6', borderRadius: '12px', borderLeft: '5px solid #ffc107' }}>
                                <CardBody className="py-3 d-flex justify-content-between align-items-center">
                                    <div>
                                        <p className="small text-muted mb-0 fw-bold text-uppercase">Total Operational Expense</p>
                                        <h3 className="mb-0 fw-bold text-dark" style={{ letterSpacing: '1px' }}>
                                            ₹{parseFloat(summary.overall_total_amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                                        </h3>
                                    </div>
                                    <div className="text-end">
                                        <Badge color="warning" className="px-3 py-2 rounded-pill text-dark">
                                            {summary.total_records} Records Found
                                        </Badge>
                                    </div>
                                </CardBody>
                            </Card>
                        </div>

                        {/* Date Filter */}
                        <div className="p-3">
                            <Row className="g-2 align-items-end bg-white p-2 rounded-3 border">
                                <Col md={5}>
                                    <label className="extra-small fw-bold text-muted text-uppercase">From Date</label>
                                    <DatePicker 
                                        value={expFilters.from} 
                                        onChange={(v) => setExpFilters({...expFilters, from: v})} 
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }} 
                                    />
                                </Col>
                                <Col md={5}>
                                    <label className="extra-small fw-bold text-muted text-uppercase">To Date</label>
                                    <DatePicker 
                                        value={expFilters.to} 
                                        minDate={expFilters.from || undefined}
                                        onChange={(v) => setExpFilters({...expFilters, to: v})} 
                                        slotProps={{ textField: { size: 'small', fullWidth: true } }} 
                                    />
                                </Col>
                                <Col md={2}>
                                    <Button color="dark" size="sm" block className="fw-bold py-2" onClick={() => loadExpenseHistory(selectedVehicle.id, 1)}>
                                        <i className='bx bx-filter-alt'></i>
                                    </Button>
                                </Col>
                            </Row>
                        </div>

                        <div className="table-wrap p-0">
                            <table className="table modern-table mb-0" style={{ fontSize: '13px' }}>
                                <thead className="bg-light">
                                    <tr className="text-uppercase">
                                        <th>Date</th>
                                        <th>Type</th>
                                        <th>Remarks</th>
                                        <th className="text-end">Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {expenseList.length > 0 ? (
                                        <>
                                            {expenseList.map(ex => (
                                                <tr key={ex.id}>
                                                    <td>{dayjs(ex.expense_date).format("DD-MM-YYYY")}</td>
                                                    <td><Badge color="warning" className="text-dark border-0">{ex.expense_type}</Badge></td>
                                                    <td className="small text-muted">{ex.remarks || '-'}</td>
                                                    <td className="text-end fw-bold text-danger">₹{parseFloat(ex.amount).toLocaleString('en-IN', { minimumFractionDigits: 2 })}</td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : (
                                        <tr><td colSpan="4" className="text-center py-5 text-muted">No expense records found.</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        
                        <div className="p-3 border-top bg-white mb-2">
                            <Pagination
                                page={expensePage}
                                total={expenseTotal}
                                limit={5}
                                onPrev={() => setExpensePage(p => Math.max(1, p - 1))}
                                onNext={() => setExpensePage(p => p + 1)}
                            />
                        </div>
                    </ModalBody>
                </Modal>

                {/* EXISTING VIEW MODAL */}
                <Modal isOpen={!!viewItem} toggle={() => setViewItem(null)} centered size="md" className="extraordinary-modal">
                    <ModalBody className="p-0 overflow-hidden">
                        <div className="modal-banner">
                            <div className="banner-content">
                                <div className="customer-icon"><i className='bx bxs-truck'></i></div>
                                <div className="header-text">
                                    <h5 className="text-uppercase">{viewItem?.vehicle_number}</h5>
                                    <p>{viewItem?.lorry_type}</p>
                                </div>
                            </div>
                            <button className="glass-close" onClick={() => setViewItem(null)}><i className='bx bx-x'></i></button>
                        </div>
                        <div className="modal-body-premium">
                            <div className="info-grid">
                                <div className="info-item"><i className='bx bx-truck'></i><div><span>Lorry Type</span><strong>{viewItem?.lorry_type}</strong></div></div>
                                <div className="info-item"><i className='bx bx-package'></i><div><span>Capacity</span><strong>{viewItem?.capacity}</strong></div></div>
                                <div className="info-item full-width"><i className='bx bx-check-circle'></i><div><span>Status</span><strong className={`status-badge vehicle-status ${viewItem?.status}`}>{viewItem?.status?.replace("_", " ")}</strong></div></div>
                            </div>
                            <div className="status-footer">
                                <div></div>
                                <div className="action-btns">
                                    <button className="edit-action-btn edit" onClick={() => navigate(`/vehicles/edit/${viewItem?.id}`)}><i className='bx bx-edit'></i></button>
                                    <button className="close-action-btn" onClick={() => setViewItem(null)}>Close</button>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>

                <DeleteModal
                    isOpen={!!deleteTarget}
                    toggle={() => setDeleteTarget(null)}
                    title="Delete Vehicle"
                    message={`Are you sure you want to delete vehicle ${deleteTarget?.vehicle_number || ''}?`}
                    onConfirm={async () => {
                        if (!deleteTarget) return;
                        setDeleting(true);
                        dispatch(loadingTrue());
                        const res = await Handler({
                            method: "delete",
                            url: "/vehicle/delete.php",
                            data: { id: deleteTarget.id }
                        });
                        dispatch(loadingFalse());
                        setDeleting(false);
                        if (res?.success) {
                            setDeleteTarget(null);
                            toast.success(res?.message || "Vehicle deleted successfully");
                            setData(prevData => prevData.filter(v => String(v.id) !== String(deleteTarget.id)));
                            loadVehicles();
                        } else {
                            setDeleteTarget(null);
                            toast.error(res?.message || "Failed to delete vehicle");
                        }
                    }}
                    loading={deleting}
                />
            </div>
        </LocalizationProvider>
    );
};

export default VehicleList;